








































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import SkriningPengunjungSvc from "@/services/SkriningPengunjungService";
import { appModule } from "@/store/modules/app";
import { SkriningPengunjungRow } from "@/types/skriningPengunjung";

@Component
export default class SkriningPengunjungDetailDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ type: Object, default: null }) readonly row!: SkriningPengunjungRow | null;
  @Prop({ type: Boolean, default: true }) readonly muatDetail!: boolean;
  @Prop({ type: Boolean, default: true }) readonly bolehUbah!: boolean;

  rincian: SkriningPengunjungRow | null = null;
  memuat = false;
  menghapus = false;
  konfirmasiHapus = false;

  @Watch("value")
  async onBuka(buka: boolean) {
    this.konfirmasiHapus = false;
    if (!buka || !this.row) return;

    this.rincian = this.row;

    if (!this.muatDetail || this.row.dimasking) return;

    this.memuat = true;
    try {
      this.rincian = await SkriningPengunjungSvc.detail(this.row.id);
    } catch {
      return;
    } finally {
      this.memuat = false;
    }
  }

  formatWaktu(waktu: string): string {
    return waktu ? moment(waktu, "YYYY-MM-DD HH:mm").format("DD-MM-YYYY HH:mm") : "-";
  }

  async hapus() {
    if (!this.rincian) return;

    this.menghapus = true;
    try {
      await SkriningPengunjungSvc.hapus(this.rincian.id);
      appModule.sendSuccessNotice("Data kunjungan berhasil dihapus");
      this.konfirmasiHapus = false;
      this.$emit("dihapus", this.rincian.id);
      this.$emit("input", false);
    } catch {
      return;
    } finally {
      this.menghapus = false;
    }
  }
}
